import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

function formatDetail(d) {
  if (!d) return "Login failed.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export default function AdminLogin() {
  const { user, login, ready } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center pt-24 px-6" data-testid="page-admin-login">
      <form onSubmit={submit} className="w-full max-w-md border border-white/10 p-10 md:p-14" data-testid="admin-login-form">
        <div className="h-eyebrow mb-6 text-[var(--gold)]">§ Studio Portal</div>
        <h1 className="h-display text-4xl md:text-5xl leading-none">Sign in.</h1>
        <p className="font-serif-editorial italic text-[var(--ink-muted)] mt-4">By invitation only.</p>

        <label className="block mt-10">
          <span className="h-eyebrow block mb-2">Email</span>
          <input type="email" required className="line-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
        </label>
        <label className="block mt-8">
          <span className="h-eyebrow block mb-2">Password</span>
          <input type="password" required className="line-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
        </label>

        <button type="submit" disabled={loading} className="mt-12 w-full bg-[var(--royal)] hover:bg-[var(--royal-soft)] text-white py-4 font-sans-display uppercase tracking-[0.3em] text-[11px] transition-colors disabled:opacity-60" data-testid="admin-login-submit">
          {loading ? "Entering…" : "Enter Studio →"}
        </button>
      </form>
    </main>
  );
}
